import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetNextPaymentDate_memberPackage$key } from "./__generated__/useGetNextPaymentDate_memberPackage.graphql";

export const useGetNextPaymentDate = (
  memberPackageRef: useGetNextPaymentDate_memberPackage$key | null | undefined
) => {
  const memberPackage = useFragment(
    useGetNextPaymentDateFragmentString,
    memberPackageRef
  );

  const orders =
    memberPackage?.orders?.edges?.flatMap((edge) =>
      edge?.node ? [edge.node] : []
    ) || [];

  const unpaidOrders =
    orders.flatMap((order) => (order && !order.isPaid ? [order] : [])) || [];

  const nextOrder = unpaidOrders[0];

  return nextOrder?.packageDueDate;
};

const useGetNextPaymentDateFragmentString = graphql`
  fragment useGetNextPaymentDate_memberPackage on MemberPackage {
    orders {
      edges {
        node {
          isPaid
          packageDueDate
        }
      }
    }
  }
`;
